<template>
  <v-card id="consuntivo_work_order">
    <v-toolbar
      class="white--text"
      color="indigo"
      dense
      style="position: sticky; top: 0px; z-index: 1"
    >
      <v-toolbar-title> Seleziona il Work Order </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- Bottone di avvio multiplo dei WO -->
      <v-btn
        class="ma-5"
        @click="clickAvviaMultiploWO"
        color="success"
        dark
        :disabled="
          items_wo_visualizzati.filter((e) => e.selezionato === true).length ===
          0
        "
        v-if="avvio_multiplo_enabled === 1"
      >
        AVVIO MULTIPLO
      </v-btn>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="clickChiudi" small v-bind="attrs" v-on="on">
            <v-icon color="error">mdi-close</v-icon>
          </v-btn>
        </template>
        <span>Chiudi</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text class="pa-0" style="overflow-y: auto">
      <v-container>
        <v-row align="center" justify="center">
          <v-col>
            <v-text-field
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              label="Codice Articolo"
              style="display: inline-block; max-width: 350px"
              v-model="cod_articolo_sel"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    cod_articolo_sel = '';
                    filtra();
                  "
                  color="primary"
                  >{{
                    cod_articolo_sel == "" ? "mdi-filter" : "mdi-filter-off"
                  }}</v-icon
                >
              </template>
            </v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              label="Des. Articolo"
              style="display: inline-block"
              v-model="des_articolo_sel"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    des_articolo_sel = '';
                    filtra();
                  "
                  color="primary"
                  >{{
                    des_articolo_sel == "" ? "mdi-filter" : "mdi-filter-off"
                  }}</v-icon
                >
              </template>
            </v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              label="Codice Commessa"
              style="display: inline-block"
              v-model="cod_commessa_sel"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    cod_commessa_sel = '';
                    filtra();
                  "
                  color="primary"
                  >{{
                    cod_commessa_sel == "" ? "mdi-filter" : "mdi-filter-off"
                  }}</v-icon
                >
              </template></v-text-field
            >
          </v-col>
          <v-col v-if="filtro_cod_macchina_visible === true">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="items_consuntivo"
              :item-text="(e) => e.cod_macchina"
              item-value="cod_macchina"
              label="Cod. Macchina"
              style="display: inline-block"
              v-model="cod_macchina_sel"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    cod_macchina_sel = null;
                    filtra();
                  "
                  color="primary"
                  >{{
                    cod_macchina_sel == null ? "mdi-filter" : "mdi-filter-off"
                  }}</v-icon
                >
              </template>
            </v-autocomplete>
          </v-col>
          <v-col>
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="items_consuntivo"
              item-text="des"
              item-value="des"
              label="Lavorazione"
              style="display: inline-block"
              v-model="lavorazione_sel"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    lavorazione_sel = null;
                    filtra();
                  "
                  color="primary"
                  >{{
                    lavorazione_sel == null ? "mdi-filter" : "mdi-filter-off"
                  }}</v-icon
                >
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
        <!--<p
          style="
            font-size: 20px;
            line-height: 20px;
            margin-bottom: 30px;
            margin-top: 30px;
          "
        >
          Sono elencati di seguito i Work Orders disponibili:
        </p>-->
        <v-data-table
          fixed-header
          :headers="headers_consuntivo"
          height="65vh"
          :items="
            items_wo_visualizzati.filter((e) => e.pezzi_registrati < e.quantita)
          "
          :item-class="evidenzia"
          class="elevation-1 mt-5"
        >
          <!-- Pulsante per la registrazione dei pezzi -->
          <template v-slot:item="{ item }">
            <tr>
              <td :class="evidenzia(item)" v-if="avvio_multiplo_enabled === 1">
                <v-simple-checkbox
                  color="primary"
                  v-model="item.selezionato"
                  v-show="
                    !(item.macchina_impegnata == 1 && item.multicommessa == 0)
                  "
                >
                </v-simple-checkbox>
              </td>
              <td :class="evidenzia(item)">{{ item.cod_articolo }}</td>
              <td :class="evidenzia(item)" style="text-align: left">
                {{ item.des_articolo }}
              </td>
              <td :class="evidenzia(item)">{{ item.cod_commessa }}</td>
              <td :class="evidenzia(item)">{{ item.cod_fase }}</td>
              <td :class="evidenzia(item)">{{ item.cod_macchina }}</td>
              <td :class="evidenzia(item)">{{ item.des }}</td>
              <td :class="evidenzia(item)">{{ item.quantita }}</td>
              <td :class="evidenzia(item)">{{ item.pezzi_registrati }}</td>
              <td :class="evidenzia(item)">
                <div style="text-align: center">
                  <v-btn
                    class="ma-5"
                    @click="clickAvviaWO(item)"
                    color="success"
                    dark
                    large
                  >
                    AVVIA WORK ORDER
                  </v-btn>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-container>
    </v-card-text>

    <!-- Dialog di conferma attivazione -->
    <v-dialog persistent v-model="conferma_dialog" width="unset">
      <v-card>
        <v-toolbar class="white--text" color="indigo" flat>
          <v-toolbar-title>Conferma attivazione</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="font-size: 20px">
          Vuoi avviare il work order n.
          <b>{{
            work_order_sel == null
              ? ""
              : work_order_sel.cod_commessa + "." + work_order_sel.cod_fase
          }}</b
          >?
        </v-card-text>
        <v-divider></v-divider>
        <v-btn
          class="mx-2 my-2"
          @click="
            (conferma_dialog = !conferma_dialog),
              (work_order_sel = Object.assign({}))
          "
          color="error"
          dark
          style="font-size: 20px"
        >
          ANNULLA
        </v-btn>
        <v-btn
          class="mx-2 my-2"
          @click="addToCarrello(work_order_sel)"
          color="success"
          dark
          style="font-size: 20px"
        >
          CONFERMA
        </v-btn>
      </v-card>
      <v-overlay
        color="rgba(0, 0, 0, 1)"
        style="position: absolute"
        :value="caricamento_dati"
      >
        <v-icon class="ConsuntivoWORuota" size="100">mdi-cog</v-icon>
        <v-icon class="ConsuntivoWOControruota" size="100">mdi-cogs</v-icon>
      </v-overlay>
    </v-dialog>

    <!-- Dialog di conferma attivazione multipla -->
    <v-dialog persistent v-model="conferma_dialog_avvio_multiplo" width="unset">
      <v-card>
        <v-toolbar class="white--text" color="indigo" flat>
          <v-toolbar-title>Conferma attivazione</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="font-size: 20px">
          Confermi di voler avviare i Work Order selezionati?
        </v-card-text>
        <v-divider></v-divider>
        <v-btn
          class="mx-2 my-2"
          @click="
            (conferma_dialog_avvio_multiplo = !conferma_dialog_avvio_multiplo),
              (items_work_orders_sel = new Array())
          "
          color="error"
          dark
          style="font-size: 20px"
        >
          ANNULLA
        </v-btn>
        <v-btn
          class="mx-2 my-2"
          @click="addMultipleToCarrello"
          color="success"
          dark
          style="font-size: 20px"
        >
          CONFERMA
        </v-btn>
      </v-card>
      <v-overlay
        color="rgba(0, 0, 0, 1)"
        style="position: absolute"
        :value="caricamento_dati"
      >
        <v-icon class="ConsuntivoWORuota" size="100">mdi-cog</v-icon>
        <v-icon class="ConsuntivoWOControruota" size="100">mdi-cogs</v-icon>
      </v-overlay>
    </v-dialog>

    <!-- Mini dialog per indicare gli impegni delle macchine -->
    <v-dialog v-model="dialog_impegni" width="unset">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Impegni </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            @click="
              dialog_impegni = false;
              conferma_dialog = false;
            "
            small
          >
            <v-icon color="error"> mdi-close </v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pt-3">
          <div style="display: inline-block; max-width: 500px">
            <span style="font-size: 15px">
              Questo Work Order non è disponibile per il carrello delle
              lavorazioni perché tutte le macchine ad esso associate risultano
              attualmente impegnate:
            </span>
          </div>
          <v-data-table
            :headers="headers_macchine_impegnate"
            hide-default-footer
            :items="items_macchine_impegnate"
          >
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :timeout="3000">
      {{ snackbar_text }}
      <v-btn
        @click="snackbar = false"
        class="ml-5"
        :color="snackbar_color"
        fab
        outlined
        x-small
        style="background-color: #ffffff"
      >
        <v-icon>{{ snackbar_icon }}</v-icon>
      </v-btn>
    </v-snackbar>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>

<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "ConsuntivoWorkOrder",
  props: {
    avvio_multiplo_enabled: {
      type: Number,
      default: 0,
    },
    filtro_cod_macchina_visible: {
      type: Boolean,
      default: true,
    },
    items_consuntivo: { type: Array, default: () => [] },
    visible: { type: Boolean, default: false },
  },
  components: {
    SnackbarQV,
  },
  data() {
    return {
      // Variabili d'appoggio
      cod_articolo_sel: "",
      cod_commessa_sel: "",
      cod_macchina_sel: null,
      des_articolo_sel: "",
      lavorazione_sel: null,
      work_order_sel: null,

      // Modal
      caricamento_dati: false,
      conferma_dialog: false,
      conferma_dialog_avvio_multiplo: false,
      dialog_impegni: false,
      snackbar: false,
      snackbar_color: "",
      snackbar_icon: "",
      snackbar_text: "",

      // Array
      headers_consuntivo: [
        {
          text: "Cod. Articolo",
          sortable: false,
          value: "cod_articolo",
          class: "white--text indigo",
        },
        {
          text: "Des. Articolo",
          sortable: false,
          value: "des_articolo",
          class: "white--text indigo",
        },
        {
          text: "Cod. Commessa",
          sortable: false,
          value: "cod_commessa",
          class: "white--text indigo",
        },
        {
          text: "Work Order",
          sortable: false,
          value: "cod_fase",
          class: "white--text indigo",
        },
        {
          text: "Cod. Macchina",
          sortable: false,
          value: "cod_macchina",
          class: "white--text indigo",
        },
        {
          text: "Lavorazione",
          sortable: false,
          value: "des",
          class: "white--text indigo",
        },
        {
          text: "Qta Totale",
          sortable: false,
          value: "quantita",
          class: "white--text indigo",
        },
        {
          text: "Qta Prodotta",
          sortable: false,
          value: "pezzi_registrati",
          class: "white--text indigo",
        },
        {
          text: "",
          sortable: false,
          value: "avvia_work_order",
          class: "white--text indigo",
        },
      ],
      headers_macchine_impegnate: [
        {
          text: "Cod. Macchina",
          sortable: false,
          value: "cod_macchina",
        },
        {
          text: "Utente",
          sortable: false,
          value: "nominativo",
        },
        {
          text: "Cod. Commessa",
          sortable: false,
          value: "cod_commessa",
        },
        {
          text: "Ora Start",
          sortable: false,
          value: "data_inizio",
        },
      ],
      items_macchine_impegnate: new Array(),
      items_work_orders_sel: new Array(),
      items_wo_visualizzati: new Array(),
    };
  },
  methods: {
    addToCarrello(arg) {
      /* Controllo che la macchina non sia già
       * impegnata per qualche altro Work Order. */
      if (arg.macchina_impegnata == 1 && arg.multicommessa == 0) {
        this.checkImpegnoMacchine(arg);
        return;
      }

      this.caricamento_dati = true;

      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getworkordersutente",
          token: localStorage.getItem("user_token"),
          id_commessa_dettaglio: arg.id_commessa_dettaglio,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            // Compongo un messaggio con il contenuto del row cliccato.
            let messaggio = {
              detail: {
                work_order_sel: res.data.workorders.workorder[0],
              },
              src: null,
            };

            // Inserisco il messaggio in un evento custom.
            let evento = new CustomEvent("clicked_row", messaggio);

            /* Consegno alla mia destinazione l'evento con il
             * contenuto del row che ho cliccato. */
            document
              .getElementById("listener_Produzione2")
              .dispatchEvent(evento);

            /* Segnalo al padre che è stato scelto un work order,
             * così lui può chiudermi se vuole. */
            this.$emit("inviato_elemento");
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }

          // Chiudo il dialog di conferma
          this.conferma_dialog = false;

          // Chiudo l'overlay di caricamento
          this.caricamento_dati = false;
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    addMultipleToCarrello() {
      /* Controllo che nessun WO sia legato a una
       * macchina che compare più volte nella lista
       * (a meno che la macchina sia multicommessa). */
      let check_macchina_doppiata = false;
      for (let i = 0; i < this.items_work_orders_sel; i++) {
        if (
          this.items_work_orders_sel.filter(
            (e) =>
              e.id_macchina === this.items_work_orders_sel[i].id_macchina &&
              this.items_work_orders_sel[i].multicommessa !== 1
          ).length > 1
        ) {
          this.$refs.SnackbarQV.print(
            "orange",
            `Impossibile aprire più WO su una stessa macchina (${this.items_work_orders_sel[i].cod_macchina}) se questa non è multicommessa.`
          );
          check_macchina_doppiata = true;
          break;
        }
      }

      if (check_macchina_doppiata === true) {
        return;
      }

      // Se ho passato i controlli, eseguo il salvataggio.

      // Mi faccio un collettore di WO.
      const lista_wo = new Array();

      this.items_work_orders_sel.forEach((wo) => {
        this.caricamento_dati = true;

        let request = {
          controller: "Magazzino",
          method: "POST",
          richiesta: {
            action: "getworkordersutente",
            token: localStorage.getItem("user_token"),
            id_commessa_dettaglio: wo.id_commessa_dettaglio,
          },
        };

        this.$store.dispatch("api", request).then((res) => {
          if (res.status === 200) {
            // Metto il WO dettagliato nella mia lista
            lista_wo.push(res.data.workorders.workorder[0]);

            // Se mi sono arrivati tutti i WO dettagliati che mi servivano...
            if (this.items_work_orders_sel.length === lista_wo.length) {
              // Compongo un messaggio con il contenuto del row cliccato.
              let messaggio = {
                detail: {
                  workorders: lista_wo,
                },
                src: null,
              };

              // Inserisco il messaggio in un evento custom.
              let evento = new CustomEvent("clicked_row_start_it", messaggio);

              /* Consegno alla mia destinazione l'evento con il
               * contenuto del row che ho cliccato. */
              document
                .getElementById("listener_Produzione2")
                .dispatchEvent(evento);
            }
          }

          // Chiudo il dialog di conferma
          // Chiudo l'overlay di caricamento
          this.caricamento_dati = false;
        });
      });

      /* Chiudo il dialog di conferma ed emetto un evento
       * per fare chiudere al padre il dialog dei consuntivi. */
      this.conferma_dialog_avvio_multiplo = false;
      this.$emit("inviato_elemento");
    },
    checkImpegnoMacchine(arg) {
      const request = {
        controller: "MAGAZZINO",
        method: "POST",
        richiesta: {
          action: "checkworkorder",
          token: localStorage.user_token,
          id_commessa_dettaglio: arg.id_commessa_dettaglio,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.items_macchine_impegnate = new Array();
            res.data.result.forEach((e) => {
              this.items_macchine_impegnate.push(Object.assign(e));
            });
            this.dialog_impegni = true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch(() => {
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    clickAvviaMultiploWO() {
      // Controllo che ci sia almeno un WO selezionato.
      if (
        this.items_wo_visualizzati.filter((e) => e.selezionato == true)
          .length == 0
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Non è stato selezionato alcun Work Order."
        );
        return;
      }

      // Registro i WO selezionati e apro un dialog di conferma.
      this.items_work_orders_sel = new Array();
      this.items_wo_visualizzati
        .filter((e) => e.selezionato == true)
        .forEach((wo) => {
          this.items_work_orders_sel.push(Object.assign({}, wo));
        });

      // Controllo che nessuna macchina dei WO selezionati sia attualmente impegnata.
      if (
        this.items_work_orders_sel.filter(
          (e) => e.macchina_impegnata === 1 && e.multicommessa === 0
        ).length > 0
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Alcune macchine risultano impegnate. Selezionare solo WO per macchine attualmente libere."
        );
        return;
      }

      /* Controllo che fra i WO da aggiungere non ce ne siano 2 della stessa fase
       * (non posso avviare contemporaneamente 2 fasi diverse della stessa commessa). */
      let chk_wo_stessa_commessa = false;
      this.items_work_orders_sel.forEach((wo) => {
        if (
          this.items_work_orders_sel.filter(
            (e) => e.cod_commessa === wo.cod_commessa
          ).length > 1
        ) {
          chk_wo_stessa_commessa = true;
        }
      });

      if (chk_wo_stessa_commessa === true) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Non si possono avviare contemporaneamente più Work Order della stessa commessa."
        );
        return;
      }

      this.conferma_dialog_avvio_multiplo = true;
    },
    clickAvviaWO(item) {
      console.log(JSON.stringify(item));
      this.work_order_sel = Object.assign({}, item);
      this.conferma_dialog = true;
    },
    clickChiudi() {
      this.$emit("click_chiudi");

      // Resetto i filtri
      this.cod_articolo_sel = "";
      this.cod_commessa_sel = "";
      this.cod_macchina_sel = null;
      this.des_articolo_sel = "";
      this.lavorazione_sel = null;
    },
    evidenzia(item) {
      return this.evidenziaImpegno(item);
    },
    evidenziaImpegno(item) {
      return item.macchina_impegnata == 1 && item.multicommessa == 0
        ? "ConsuntivoWOImpegnato"
        : "";
    },
    filtra() {
      let items_wo_tmp = [];
      this.items_consuntivo.forEach((elem) => {
        items_wo_tmp.push(elem);
      });

      // Filtro il codice articolo
      if (this.cod_articolo_sel != "") {
        // Faccio un array temporaneo
        let res = [];

        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_wo_tmp.forEach((elem) => {
          if (
            elem.cod_articolo
              .toUpperCase()
              .includes(this.cod_articolo_sel.toUpperCase())
          ) {
            res.push(elem);
          }
        });

        // Modello la risposta provvisoria su "res".
        items_wo_tmp = res;
      }

      // Filtro il codice commessa
      if (this.cod_commessa_sel != "") {
        // Faccio un array temporaneo
        let res = [];

        // Filtro gli elementi visualizzati dopo i passaggi precedenti
        items_wo_tmp.forEach((elem) => {
          if (elem.cod_commessa.includes(this.cod_commessa_sel)) {
            res.push(elem);
          }
        });

        items_wo_tmp = res;
      }

      // Filtro la descrizione articolo
      if (this.des_articolo_sel != "") {
        // Faccio un array temporaneo
        let res = [];

        // Filtro gli elementi visualizzati dopo i passaggi precedenti
        items_wo_tmp.forEach((elem) => {
          if (
            elem.des_articolo
              .toUpperCase()
              .includes(this.des_articolo_sel.toUpperCase())
          ) {
            res.push(elem);
          }
        });

        items_wo_tmp = res;
      }

      // Filtro il codice macchina
      if (this.cod_macchina_sel != null) {
        // Faccio un array temporaneo
        let res = [];

        // Filtro gli elementi visualizzati dopo i passaggi precedenti
        items_wo_tmp.forEach((elem) => {
          if (elem.cod_macchina == this.cod_macchina_sel) {
            res.push(elem);
          }
        });

        items_wo_tmp = res;
      }

      // Filtro la lavorazione
      if (this.lavorazione_sel != null) {
        // Faccio un array temporaneo
        let res = [];

        // Filtro gli elementi visualizzati dopo i passaggi precedenti
        items_wo_tmp.forEach((elem) => {
          if (elem.des == this.lavorazione_sel) {
            res.push(elem);
          }
        });

        items_wo_tmp = res;
      }

      this.items_wo_visualizzati = [];
      this.items_wo_visualizzati = items_wo_tmp;
      this.items_wo_visualizzati.sort(
        (a, b) => parseFloat(a.cod_fase) - parseFloat(b.cod_fase)
      );
    },
  },
  watch: {
    items_consuntivo: {
      immediate: true,
      handler() {
        /* Se la lista dei WO dovesse cambiare per qualche motivo,
         * facci in modo di avere gli aggiornamenti. */
        this.items_wo_visualizzati = new Array();
        this.items_consuntivo.forEach((e) => {
          this.items_wo_visualizzati.push(Object.assign({}, e));
        });
        //this.items_wo_visualizzati.sort((a, b) => parseFloat(a.cod_fase) - parseFloat(b.cod_fase));
        // Filtro la lista aggiornata, nel caso l'utente avesse disposto dei filtri
        this.filtra();
      },
    },
  },
  mounted() {
    if (this.avvio_multiplo_enabled === 1) {
      this.headers_consuntivo.unshift({
        text: "Selezione",
        sortable: false,
        value: "selezione",
        class: "white--text indigo",
      });
    }
  },
};
</script>

<style>
.ConsuntivoWOImpegnato {
  background-color: orange;
}
.ConsuntivoWONormale {
  background-color: white;
}
</style>
<style scoped>
@keyframes ConsuntivoWOControtazione {
  0% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
@keyframes ConsuntivoWORotazione {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.ConsuntivoWOControruota {
  animation: ConsuntivoWOControtazione 1s infinite;
  animation-timing-function: linear;
}

.ConsuntivoWORuota {
  animation: ConsuntivoWORotazione 1s infinite;
  animation-timing-function: linear;
}
</style>
